import React, { useEffect, useState } from 'react';
// Desdin System
import AutocompleteComponent from 'components/design-system/Autocomplete/Autocomplete';
import InputComponent from 'components/design-system/input/Input';
import LabelComponent from 'components/design-system/Label/Label';
import Text from 'components/design-system/Text/Text';

import {
  CargaActividades,
  obtenerEmpresasAT
} from 'views/CargaMasiva/hooks/useServices';
import { handleKeyPress } from '../utils/handleKeyPress';
import { handleKeyPressNumeros } from '../utils/handleKeyPressNumeros';
import TransferListComponent from 'components/design-system/TransferList/TransferList';
import AlertComponent from 'components/design-system/Alert/Alert';
// Selectors
import { SelectorDireccionContainer } from 'hooks/Selectors/hooks';

const FormularioEditarEmpresasAT = ({
  handleChange,
  handleBlur,
  values,
  errors,
  touched,
  setFieldValue,
  setFieldTouched,
  isSubmitting
}) => {
  // Actividades
  const [actividades, setActividades] = useState([]);
  const [isLoadingActividades, setIsLoadingActividades] = useState(true);

  useEffect(() => {
    CargaActividades({ setIsLoadingActividades, setActividades });
  }, []);

  //Sinergias
  const [empresasAT, setEmpresasAt] = useState([]);
  const [isLoadingEmpresasAt, setIsLoadingEmpresasAt] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const [paginationEmpresasAt, setPaginationEmpresasAt] = useState({
    pageIndex: 0,
    pageSize: 50
  });

  useEffect(() => {
    obtenerEmpresasAT({
      setIsLoading: setIsLoadingEmpresasAt,
      pagination: paginationEmpresasAt,
      setEmpresasAt: setEmpresasAt,
      setRowCount: setRowsPerPage
    });
  }, [paginationEmpresasAt]);

  useEffect(() => {
    if (!empresasAT) return;
  }, [empresasAT]);

  return (
    <>
      {/* RUT  */}
      <div className="col-span-3  xxs:col-span-12 xs:col-span-12  lg:col-span-3">
        <InputComponent
          autoComplete={'off'}
          fullWidth
          label={<LabelComponent>Rut empresa</LabelComponent>}
          name="rutEmpresa"
          onChange={e => {
            handleChange(e);
          }}
          onBlur={e => {
            handleBlur(e);
          }}
          value={values.rutEmpresa}
          outerInputProps={{
            inputProps: {
              maxLength: 11,
              onKeyPress: handleKeyPress
            }
          }}
          touched={touched.rutEmpresa}
          estado={
            errors.rutEmpresa
              ? { tipo: 'error', mensaje: errors.rutEmpresa }
              : null
          }
        />
      </div>
      {/* Razon Social */}
      <div className="col-span-9 xxs:col-span-12  xs:col-span-12   lg:col-span-9">
        <InputComponent
          autoComplete={'off'}
          // disabled={
          //   errors.rutEmpresa || !values.rutEmpresa ? true : false
          // }
          fullWidth
          label={<LabelComponent>Razón social</LabelComponent>}
          name="razonSocial"
          onBlur={e => {
            handleBlur(e);
          }}
          onChange={ev => {
            ev && handleChange(ev) && setFieldTouched('rubro');
            !ev && setFieldValue('razonSocial', '');
          }}
          value={values.razonSocial ? values.razonSocial : ''}
          touched={touched.razonSocial}
          estado={
            errors.razonSocial
              ? { tipo: 'error', mensaje: errors.razonSocial }
              : null
          }
        />
      </div>
      {/* Tramo */}
      <div className="col-span-3 xxs:col-span-12  xs:col-span-12   lg:col-span-3">
        <InputComponent
          autoComplete={'off'}
          // disabled={
          //   errors.rutEmpresa || !values.rutEmpresa ? true : false
          // }
          fullWidth
          label={<LabelComponent>Tramo</LabelComponent>}
          name="tramo"
          onBlur={e => {
            handleBlur(e);
          }}
          onChange={ev => {
            ev && handleChange(ev) && setFieldTouched('tramo');
            !ev && setFieldValue('tramo', '');
          }}
          value={values.tramo ? values.tramo : ''}
          outerInputProps={{
            inputProps: {
              maxLength: 100,
              onKeyPress: handleKeyPressNumeros
            }
          }}
          touched={touched.tramo}
          estado={
            errors.tramo ? { tipo: 'error', mensaje: errors.tramo } : null
          }
        />
      </div>
      {/* Actividad */}
      <div className="col-span-9 xxs:col-span-12  xs:col-span-12   lg:col-span-9">
        <AutocompleteComponent
          name="actividad"
          accesor={'label'}
          clearOnEscape={true}
          openOnFocus={false}
          options={actividades || []}
          isLoading={isLoadingActividades}
          // disabled={isLoadingActividades}
          onBlur={() => setFieldTouched('actividad')}
          onChange={(ev, selected, reason) => {
            let data = { name: 'actividad', value: selected };
            if (reason === 'clear') {
              data.value = '';
            }
            setFieldValue('actividad', data.value);
          }}
          value={values.actividad || ''}
          getOptionLabel={option =>
            option.label || values.actividad?.nombreActividad || ''
          }
          touched={touched.actividad}
        >
          <InputComponent
            autoComplete={'off'}
            // disabled={errors.rutEmpresa}
            fullWidth
            label={<LabelComponent>Actividad</LabelComponent>}
            touched={touched.actividad}
            estado={
              errors.actividad
                ? { tipo: 'error', mensaje: errors.actividad }
                : null
            }
          />
        </AutocompleteComponent>
      </div>
      {/* Direccion */}
      <SelectorDireccionContainer
        values={values}
        errors={errors}
        touched={touched}
        onChange={handleChange}
        handleBlur={handleBlur}
        setFieldTouched={setFieldTouched}
        setFieldValue={setFieldValue}
        isSubmitting={isSubmitting}
        subtitle=""
        className="grid grid-cols-12 gap-4 "
        classNameRegion="col-span-3 xxs:col-span-12 xs:col-span-12 lg:col-span-3"
        classNameComuna="col-span-3 xxs:col-span-12 xs:col-span-12 lg:col-span-3"
        classNameNombreVia="col-span-6 xxs:col-span-12 xs:col-span-12 lg:col-span-6"
      />

      {/* TransferList */}
      <div className="col-span-12  xxs:col-span-12 xs:col-span-12 ">
        <Text className="text-secondary font-semibold mt-2 mb-2">
          Potencial de sinergías
        </Text>
        {/* Alerta mensaje con indicaciones */}
        <div className="col-span-12">
          <AlertComponent className="mb-2" type="info">
            <strong>Selecciona </strong> una o más empresas de la columna*{' '}
            <strong>Empresas de análisis territorial*</strong> y agrégalas a la
            columna de <strong>Empresa Destino*</strong> para indicar la
            relación de potencial de sinergia de la empresa a crear.
          </AlertComponent>
        </div>

        <TransferListComponent
          accesor={'razonSocial'}
          codigo={'codigoEmpresaAT'}
          isLoading={isLoadingEmpresasAt}
          label=""
          labelEditar={'empresaATDestino'}
          mostrarLabel={'razonSocial'}
          name="potencialSinergias"
          options={empresasAT || []}
          pageIndex={paginationEmpresasAt.pageIndex}
          pageSize={paginationEmpresasAt.pageSize}
          setFieldTouched={setFieldTouched}
          setFieldValue={setFieldValue}
          setPagination={setPaginationEmpresasAt}
          title="Empresas de análisis territorial"
          titleDestino="Empresa Destino"
          total={rowsPerPage}
          touched={touched.potencialSinergias}
          values={values.potencialSinergias || []}
          disabled={true}
          estado={
            errors.potencialSinergias
              ? { tipo: 'error', mensaje: errors.potencialSinergias }
              : null
          }
        />
      </div>
    </>
  );
};

export default FormularioEditarEmpresasAT;
